export const CLAIM = "CLAIM";
export const MOBILE_APPS_PROMO_CLAIM = "MOBILE_APPS_PROMO_CLAIM";